export default function getResource(label, vars = []) {
    const resources = {
        tabRewards: 'Rewards',
        tabEarnPoints: 'Earn Points',
        tabBenefits: 'Benefits',
        tabHistory: 'History'
    };
    return resources[label];
}
